import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExclamationTriangle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.7998 22L12.7998 3L23.7998 22H1.7998ZM20.3298 20L12.7998 6.99L5.2698 20H20.3298ZM11.7998 17V19H13.7998V17H11.7998ZM11.7998 11H13.7998V15H11.7998V11Z",
			fill: "#ED847E"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0",
			"mask-type": "alpha",
			maskUnits: "userSpaceOnUse",
			x: 1,
			y: 3,
			width: 23,
			height: 19,
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M1.7998 22L12.7998 3L23.7998 22H1.7998ZM20.3298 20L12.7998 6.99L5.2698 20H20.3298ZM11.7998 17V19H13.7998V17H11.7998ZM11.7998 11H13.7998V15H11.7998V11Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", { mask: "url(#mask0)" })
	]
});
const ForwardRef = forwardRef(SvgExclamationTriangle);
export default ForwardRef;
